<div class="top-8 sticky mb-8 md:mb-0 h-fit">
    <div
        class="shadow-[0_0_10px_4px_rgba(0,0,0,0.1)] p-4 border border-neutral-400 rounded-2xl"
        [ngClass]="{
            'border-red-500':
                bookingService.formState() ===
                bookingService.formStateEnum.Invalid,
        }"
    >
        @if (config()?.data?.bookingsPossible) {
            @defer {
                <app-date-picker
                    (startDate)="
                        handleSignalChange(
                            $event,
                            bookingService.startDate,
                            true
                        )
                    "
                    (endDate)="
                        handleSignalChange($event, bookingService.endDate)
                    "
                    (selectedDaysAmount)="
                        handleSignalChange($event, daysAmount)
                    "
                    [config]="config()"
                ></app-date-picker>
            }
            <div
                class="m-2 mb-4 text-neutral-500 text-sm"
                [ngClass]="{
                    'text-red-500':
                        bookingService.startDate() && !bookingService.endDate(),
                }"
            >
                @if (daysAmount() >= minRangeSpan()) {
                    {{ daysAmount() }}
                    {{ "booking.bookingForm.daysSelected" | translate }}
                } @else {
                    {{
                        "booking.bookingForm.selectMinNDays"
                            | translate: { days: minRangeSpan() }
                    }}
                }
            </div>
            <app-person-selection
                [label]="'booking.bookingForm.adultsAge' | translate"
                [price]="applicableSeason()?.subSeason?.adultPrice || 0"
                [min]="1"
                [disabled]="getTotalPersonAmount() >= maximumGuests()"
                (selectedPersonsEmit)="
                    handleSignalChange($event, bookingService.adultAmount)
                "
            ></app-person-selection>
            <app-person-selection
                [label]="'booking.bookingForm.childrenAge' | translate"
                [price]="applicableSeason()?.subSeason?.childPrice || 0"
                [disabled]="getTotalPersonAmount() >= maximumGuests()"
                (selectedPersonsEmit)="
                    handleSignalChange($event, bookingService.childrenAmount)
                "
            >
            </app-person-selection>
            <app-person-selection
                [label]="'booking.bookingForm.infantsAge' | translate"
                [price]="0"
                [disabled]="getTotalPersonAmount() >= maximumGuests()"
                (selectedPersonsEmit)="
                    handleSignalChange($event, bookingService.infantsAmount)
                "
            ></app-person-selection>
            <div class="m-2 text-neutral-500 text-sm help">
                {{
                    "booking.bookingForm.maxNPersons"
                        | translate: { persons: maximumGuests() }
                }}:
            </div>
            @if (
                applicableSeason() &&
                getTotalPersonAmount() > 0 &&
                daysAmount() >= minRangeSpan()
            ) {
                <app-divider style="padding: 0"></app-divider>
                <div class="flex justify-between mt-2 text-lg">
                    <p>
                        {{ getPricePerNight() }} € x {{ daysAmount() - 1 }}
                        {{ "booking.bookingForm.nights" | translate }}
                    </p>
                    <p>{{ getPricePerNight() * (daysAmount() - 1) }} €</p>
                </div>
                <div class="flex justify-between my-2 text-lg">
                    <p>
                        {{ "booking.bookingForm.cleaningCosts" | translate }}
                    </p>
                    <p>{{ getCleaningCosts() }} €</p>
                </div>
                <app-divider style="padding: 0"></app-divider>
                <div class="flex justify-between mt-2 mb-4 text-xl">
                    <p>
                        {{ "booking.bookingForm.totalPrice" | translate }}
                    </p>
                    <p>{{ getTotalPrice() }} €</p>
                </div>
                <a
                    routerLink="./"
                    fragment="reservieren"
                    (click)="viewportScroller.setOffset([0, 32])"
                >
                    <app-button class="block justify-self-center">
                        {{ "booking.bookingForm.reserve" | translate }}
                    </app-button>
                </a>
            }
        } @else {
            <p class="text-red-500 text-lg">
                {{ "booking.bookingForm.bookingsNotPossible" | translate }}
            </p>
        }
    </div>
    <div class="pl-4 ~mt-4/8">
        <ul class="list-disc list-inside">
            <li class="mb-2 text-base">
                {{ "booking.bookingForm.minimumStay" | translate }}:
                {{ (config()?.data?.minimumStay || 4) - 1 }}
                {{ "booking.bookingForm.nights" | translate }}
            </li>
            <li class="mb-2 text-base">
                Check-In: {{ "booking.bookingForm.from" | translate }}
                {{ formatTime(config()?.data?.checkInTime) }}
            </li>
            <li class="mb-2 text-base">
                Check-Out: {{ "booking.bookingForm.to" | translate }}
                {{ formatTime(config()?.data?.checkOutTime) }}
            </li>
            <li class="mb-2 text-base">
                {{ "booking.bookingForm.noPets" | translate }}
            </li>
        </ul>
    </div>
    <app-divider class="md:hidden" style="padding: 0"></app-divider>
</div>
